import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBAwGsTIxPxh-s4UwqJiIXge8Dc-zt6ivI",
  authDomain: "meitho.firebaseapp.com",
  projectId: "meitho",
  storageBucket: "meitho.firebasestorage.app",
  messagingSenderId: "61609983687",
  appId: "1:61609983687:web:f8bd4e22bd189d6f1e48e2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;